.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  padding: 5em 0;
}

.heading {
  text-align: center;
}

.li {
  margin: 0.2em 0;
}

.link {
  width: 100%;
  padding-left: 5em !important;
  padding-right: 5em !important;
  text-align: center;
}
